import React, { useEffect, useState } from "react";
// 导入样式文件
import "./home.css";
// 导入视频资源
import video from "../../Assets/home-top-video.mp4";
// 导入图标
import { GrLocation } from "react-icons/gr";
import { HiFilter } from "react-icons/hi";
import { FiFacebook } from "react-icons/fi";
import { AiOutlineInstagram } from "react-icons/ai";
import { SiTripadvisor } from "react-icons/si";
import { BsListTask } from "react-icons/bs";
import { TbApps } from "react-icons/tb";
// 导入AOS动画库及样式
import Aos from "aos";
import "aos/dist/aos.css";

const Home = () => {
  // 使用 useEffect 初始化 AOS 动画，设置动画持续时间为2000毫秒
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);

  // 新增状态，用于控制选择的国家
  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedRegion, setSelectedRegion] = useState("");
  const [selectedActivity, setSelectedActivity] = useState("");



    // 处理国家下拉菜单变化
    const handleCountryChange = (e) => {
      setSelectedCountry(e.target.value);
      // Reset region on country change
      setSelectedRegion("");
    };

  // Handler for region change (works for both input and select)
  const handleRegionChange = (e) => {
    setSelectedRegion(e.target.value);
  };

  // 处理活动下拉变化
  const handleActivityChange = (e) => {
      setSelectedActivity(e.target.value);
  };


  return (
    <section className="home">
      {/* 半透明覆盖层 */}
      <div className="overlay"></div>

      {/* 背景视频 */}
      <video muted autoPlay loop>
        <source src={video} type="video/mp4" />
      </video>

      <div className="homeContent container">
        {/* 文本内容区域 */}
        <div className="textDiv">
          {/* 小标题，使用 AOS 动画 */}
          <span data-aos="fade-up" className="smallText">
            搜 尋 自 助 旅 行
          </span>
          {/* 主标题 */}
          <h1 data-aos="fade-up" className="homeTitle">
            搜尋適合你的教育交流之旅
          </h1>
        </div>

      {/* 卡片区域，包含表单输入部分 */}
        <div data-aos="fade-up" className="cardDiv grid">
        
          {/* 国家选择下拉菜单 */}
          <div className="destinationInput">
            <label htmlFor="country">選擇國家:</label>
            <div className="input flex">
              <select 
                id="country" 
                value={selectedCountry} 
                onChange={handleCountryChange}
              >
                <option value="">請選擇國家</option>
                <option value="USA">美國</option>
                <option value="UK">英國</option>
                <option value="Canada">加拿大</option>
                <option value="Australia">澳大利亞</option>
                {/* Add more options as needed */}
              </select>
              <GrLocation className="icon" />
            </div>
          </div>

          {/* 区域选择部分 */}
           <div className="destinationInput">
            <label htmlFor="region">選擇區域:</label>
            <div className="input flex">
              {selectedCountry === "USA" ? (
                <select
                  id="region"
                  value={selectedRegion}
                  onChange={handleRegionChange}
                >
                  <option value="">請選擇州</option>
                  <option value="California">California</option>
                  <option value="New York">New York</option>
                  <option value="Texas">Texas</option>
                  <option value="Florida">Florida</option>
                  {/* Add more US states as needed */}
                </select>
              ) : selectedCountry === "UK" ? (
                <select
                  id="region"
                  value={selectedRegion}
                  onChange={handleRegionChange}
                >
                  <option value="">請選擇省/區</option>
                  <option value="England">England</option>
                  <option value="Scotland">Scotland</option>
                  <option value="Wales">Wales</option>
                  <option value="Northern Ireland">Northern Ireland</option>
                </select>
              ) : (
                <input
                  id="region"
                  type="text"
                  placeholder="選擇區域"
                  value={selectedRegion}
                  onChange={handleRegionChange}
                />
              )}
              <GrLocation className="icon" />
            </div>
          </div>

        {/* 營隊 / 活動選擇 */}
          <div className="destinationInput">
            <label htmlFor="activity">選擇你喜歡的活動:</label>
            <div className="input flex">
              <select
                id="activity"
                value={selectedActivity}
                onChange={handleActivityChange}
              >
                <option value="">請選擇活動</option>
                <option value="sport">Sport</option>
                <option value="Fun">Fun</option>
                <option value="culture">Culture</option>
                <option value="Craft">Craft</option>
                <option value="Academy">Academy</option>
              </select>
              <GrLocation className="icon" />
            </div>
          </div>
          

          {/* 搜索选项按钮 */}
          <div className="searchOptions flex">
            <HiFilter className="icon" />
            <span>點擊搜尋「功能完善中，請稍後再試。。。」</span>
          </div>
        </div>

        {/* 底部社交图标区域 */}
        <div data-aos="fade-up" className="homeFooterIcons flex">
          <div className="rightIcons">
            <FiFacebook className="icon" />
            <AiOutlineInstagram className="icon" />
            <SiTripadvisor className="icon" />
          </div>
          <div className="leftIcons">
            <BsListTask className="icon" />
            <TbApps className="icon" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Home;